import { useQuery } from '@tanstack/react-query';
import { fetchRegions } from '../../../api/administration/demographics/locations';

export const useRegions = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['regions', filters],
    queryFn: () => {
      const params = { ...filters };
      if (params?.pageSize && !params.limit) {
        params.limit = params.pageSize;
      }
      return fetchRegions(params);
    },
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.regions ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useRegions;
